import React from 'react';
import { Col, Row } from 'react-bootstrap';

export const Title: React.FC<React.PropsWithChildren<any>> = ({
  title,
  children,
  xs1 = '6',
  xs2 = '6',
  className = 'cssf-jumbotron-gray',
}) => {
  return (
    <div className={`jumbotron jumbotron-title ${className}`}>
      <div className="cssf-jumbotron-home-overlay ">
        <Row>
          <Col className="d-flex align-items-center" xs={children ? xs1 : '12'}>
            <h4 className="mb-0">{title}</h4>
          </Col>
          {children && <Col xs={xs2}>{children}</Col>}
        </Row>
      </div>
    </div>
  );
};
